export const FETCH_DEPARTMENT_DROPDOWN_DATA_START =
    "FETCH_DEPARTMENT_DROPDOWN_DATA_START";
export const FETCH_DEPARTMENT_DROPDOWN_DATA_SUCCESS =
    "FETCH_DEPARTMENT_DROPDOWN_DATA_SUCCESS";
export const FETCH_DEPARTMENT_DROPDOWN_DATA_ERROR =
    "FETCH_DEPARTMENT_DROPDOWN_DATA_ERROR";

export const FETCH_OFFICE_DROPDOWN_DATA_START =
    "FETCH_OFFICE_DROPDOWN_DATA_START";
export const FETCH_OFFICE_DROPDOWN_DATA_SUCCESS =
    "FETCH_OFFICE_DROPDOWN_DATA_SUCCESS";
export const FETCH_OFFICE_DROPDOWN_DATA_ERROR =
    "FETCH_OFFICE_DROPDOWN_DATA_ERROR";

export const FETCH_USER_DROPDOWN_DATA_START = "FETCH_USER_DROPDOWN_DATA_START";
export const FETCH_USER_DROPDOWN_DATA_SUCCESS =
    "FETCH_USER_DROPDOWN_DATA_SUCCESS";
export const FETCH_USER_DROPDOWN_DATA_ERROR = "FETCH_USER_DROPDOWN_DATA_ERROR";

export const FETCH_LANGUAGES_DROPDOWN_DATA_START =
    "FETCH_LANGUAGES_DROPDOWN_DATA_START";
export const FETCH_LANGUAGES_DROPDOWN_DATA_SUCCESS =
    "FETCH_LANGUAGES_DROPDOWN_DATA_SUCCESS";
export const FETCH_LANGUAGES_DROPDOWN_DATA_ERROR =
    "FETCH_LANGUAGES_DROPDOWN_DATA_ERROR";

export const FETCH_COUNTRIES_DROPDOWN_DATA_START =
    "FETCH_COUNTRIES_DROPDOWN_DATA_START";
export const FETCH_COUNTRIES_DROPDOWN_DATA_SUCCESS =
    "FETCH_COUNTRIES_DROPDOWN_DATA_SUCCESS";
export const FETCH_COUNTRIES_DROPDOWN_DATA_ERROR =
    "FETCH_COUNTRIES_DROPDOWN_DATA_ERROR";

export const FETCH_CLIENT_DROPDOWN_DATA_START =
    "FETCH_CLIENT_DROPDOWN_DATA_START";
export const FETCH_CLIENT_DROPDOWN_DATA_SUCCESS =
    "FETCH_CLIENT_DROPDOWN_DATA_SUCCESS";
export const FETCH_CLIENT_DROPDOWN_DATA_ERROR =
    "FETCH_CLIENT_DROPDOWN_DATA_ERROR";

export const FETCH_CURRENCIES_DROPDOWN_DATA_START =
    "FETCH_CURRENCIES_DROPDOWN_DATA_START";
export const FETCH_CURRENCIES_DROPDOWN_DATA_SUCCESS =
    "FETCH_CURRENCIES_DROPDOWN_DATA_SUCCESS";
export const FETCH_CURRENCIES_DROPDOWN_DATA_ERROR =
    "FETCH_CURRENCIES_DROPDOWN_DATA_ERROR";
